var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPandora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M37.993,10.492C35.229,7.596,31.502,6,27.5,6H10C9.448,6,9,6.447,9,7v36c0,0.553,0.448,1,1,1h8c1.654,0,3-1.346,3-3v-6 h6.119c7.971,0,14.5-6.062,14.865-13.801C42.172,17.19,40.755,13.388,37.993,10.492z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandora);
export default __webpack_public_path__ + "static/media/pandora.4b17b6cb5b8547c88f0d0125fd73ab23.svg";
export { ForwardRef as ReactComponent };